import { DocumentSearchAgentPage } from "./components/DocumentSearchAgentPage";

export default function App() {
  return <DocumentSearchAgentPage />;
}
